import AppFormItems from "@/controllers/application_form/app-form-items";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  extends: AppFormItems,

  data() {
    return {
      parentRequired: CONFIG.PARENT_REQUIRED,
      studentRequired: CONFIG.STUDENT_REQUIRED,
      studentAdditionalRequired: CONFIG.STUDENT_ADDITIONAL_REQUIRED,
      appFormType: CONFIG.APPLICATION.TYPE,
    };
  },
}
